<template>
  <f7-popup class="popup-anulacion" :opened="opened" @popup:opened="abrir" @popup:closed="$emit('cerrar')">
    <f7-page v-if="solicitud">
      <f7-navbar :title="$t('anularVacaciones.pedirTitulo', { quien: nombre })">
        <f7-nav-right>
          <f7-link popup-close>{{ $t('cerrar') }}</f7-link>
        </f7-nav-right>
      </f7-navbar>

      <!-- La cabecera de la maqueta: el código, el tramo y por qué no salen todos los días. -->
      <f7-block strong class="cabecera">
        <div class="cabecera-tramo">{{ solicitud.codigo }} · {{ fechasDe(solicitud) }}</div>
        <div class="cabecera-nota">{{ $t('anularVacaciones.soloFuturos') }}</div>
      </f7-block>

      <f7-block-title>{{ $t('anularVacaciones.diasAAnular') }}</f7-block-title>
      <f7-block strong class="dias">
        <!-- Una casilla por día de la solicitud, no solo por los que se pueden elegir: los ya
             pasados se enseñan deshabilitados y con su motivo. Escondiéndolos, quien pidió cuatro
             días veía tres casillas y no sabía qué había pasado con el otro. -->
        <label
          v-for="dia in solicitud.dias"
          :key="dia"
          class="dia"
          :class="{ 'dia-pasado': !esAnulable(dia) }"
        >
          <input
            type="checkbox"
            :checked="elegidos.indexOf(dia) >= 0"
            :disabled="!esAnulable(dia)"
            @change="alternar(dia, $event.target.checked)"
          />
          <span class="dia-fecha">{{ corta(dia) }}</span>
          <span v-if="!esAnulable(dia)" class="dia-motivo">{{ $t('anularVacaciones.yaPasado') }}</span>
        </label>
        <p v-if="!solicitud.dias.length" class="vacio">{{ $t('anularVacaciones.sinDias') }}</p>
      </f7-block>

      <!-- Desmarcar todos los días no es un estado válido: se dice en el sitio y «Enviar petición»
           se queda deshabilitado. El servidor lo rechaza igual. -->
      <f7-block v-if="!elegidos.length" strong class="aviso aviso-error">
        <p>{{ $t('anularVacaciones.eligeAlgunDia') }}</p>
      </f7-block>

      <f7-block-title>{{ $t('anularVacaciones.motivoObligatorio') }}</f7-block-title>
      <f7-block strong>
        <textarea
          class="motivo"
          rows="3"
          :value="motivo"
          :placeholder="$t('anularVacaciones.motivoPlaceholder')"
          @input="motivo = $event.target.value"
        ></textarea>
      </f7-block>

      <!-- La nota al pie de la maqueta: lo que NO va a pasar al enviar esto, que es lo que más
           tranquiliza a quien lo pide. -->
      <f7-block strong class="aviso aviso-azul">
        <p>{{ $t('anularVacaciones.siguenConfirmados', { quien: aprobador }) }}</p>
      </f7-block>

      <f7-block strong class="pie">
        <!-- Por qué no se puede enviar, pegado al botón. El aviso de arriba solo cubre los días:
             sin motivo, el botón se quedaba gris sin que nada lo explicara, y eso es lo que
             dirección prohibió el 05/10 («un control que no se puede usar dice por qué, quién lo
             desbloquea y dónde»). Se enumera TODO lo que falta en vez de lo primero que falle: así
             no hay que rellenar un campo para enterarse de que falta otro. -->
        <span v-if="!puedeEnviar" class="falta">{{ loQueFalta }}</span>
        <span class="botones">
          <f7-button :text="$t('anularVacaciones.volver')" class="display-flex" @click="$emit('cerrar')"></f7-button>
          <f7-button
            fill
            color="red"
            :text="$t('anularVacaciones.enviarPeticion')"
            :disabled="!puedeEnviar"
            class="display-flex"
            @click="enviar"
          ></f7-button>
        </span>
      </f7-block>
    </f7-page>
  </f7-popup>
</template>
<style scoped>
.cabecera { background-color: #eef6ff; border-left: 4px solid #2196f3; }
.cabecera-tramo { font-size: 15px; font-weight: bold; color: #11508c; }
.cabecera-nota { font-size: 12px; color: #11508c; margin-top: 2px; }

.dias { display: flex; flex-wrap: wrap; gap: 8px; padding: 10px; }
.dia {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #c8c9cc;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 13px;
  background-color: #fff;
}
.dia-fecha { font-weight: bold; color: #1a2744; }
.dia-pasado { background-color: #f4f5f7; color: #8e8e93; }
.dia-pasado .dia-fecha { color: #8e8e93; text-decoration: line-through; font-weight: normal; }
.dia-motivo { font-size: 11px; color: #8e8e93; }

.motivo {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #c8c9cc;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 14px;
  font-family: inherit;
}

.aviso { border-left: 4px solid #cfd4da; }
.aviso p { margin: 3px 0; font-size: 13px; }
.aviso-error { background-color: #fdecea; border-left-color: #d9534f; color: #8a1c13; }
.aviso-azul { background-color: #eef6ff; border-left-color: #2196f3; color: #11508c; }

.pie { display: flex; justify-content: flex-end; align-items: center; flex-wrap: wrap; gap: 8px; }
.falta { font-size: 12px; color: #8a1c13; margin-right: auto; }
.botones { display: flex; gap: 8px; }
.vacio { font-size: 13px; color: #8e8e93; margin: 0; }
</style>
<script>
import RhSolicitudesVacaciones from "./../../js/db/RhSolicitudesVacaciones.js";
import mensajeDelServidor from "./../../js/utils/mensajeDelServidor.js";
import textoDeLasFechas from "./../../js/utils/tramosSolicitud.js";
import accionDeLaSesion from "./../../js/utils/accionDeLaSesion.js";
import { unaAccionALaVez, claveDeSolicitud } from "./../../js/utils/unaAccionALaVez.js";
import soloMandaLaDeDelante, {
  MOTIVO_CIERRE_DE_SESION, soloMandaLaVentanaDeAhora
} from "./../../js/utils/soloMandaLaDeDelante.js";

/**
 * Ventana «Pedir anulación» (#69, punto 1): el solicitante elige qué días de unas vacaciones **ya
 * confirmadas** quiere anular y escribe por qué.
 *
 * **Esto no anula nada.** Lo que envía es una petición: los días siguen en el calendario y siguen
 * azules hasta que el aprobador la acepte o la rechace, y eso es lo que dice la nota al pie. Si se
 * anulara al pedirlo, un rechazo tendría que rehacer las tareas borradas, y una T0006 rehecha no es
 * la misma (código nuevo, planificación nueva).
 *
 * **Qué días se pueden elegir lo dice el servidor**, en `diasAnulables`, y no esta pantalla: el día
 * de corte es el suyo —hora de Madrid, la del módulo— y el del navegador puede ir uno por delante
 * o por detrás, así que calculándolo aquí la ventana ofrecería un día que el servidor rechaza, o
 * esconderia uno válido.
 */
export default {
  // Las dos piezas del módulo que una ventana que ESCRIBE tiene que llevar, y que esta ventana
  // nació sin ninguna (revisión CODEX del PR #1748, ronda 6):
  //
  //  - `soloMandaLaDeDelante` la apunta a las tres formas de dejar de estar delante —cerrar
  //    sesión, salir de la pantalla y destruirse—; la de salir se la pasa «Mis vacaciones» por
  //    `POPUPS`, que es donde también está su `ref`;
  //  - `soloMandaLaVentanaDeAhora` añade la cuarta, que es de la ventana y no de la pantalla:
  //    cerrarla o reabrirla sobre otra solicitud (ver `sujetoDeLaVentana`);
  //  - `unaAccionALaVez` es el cerrojo de ESA solicitud, el mismo que usa la bandeja, y es lo que
  //    apaga el botón mientras la petición viaja.
  //
  // Lo que ata la petición a la sesión y a la pantalla que la empezó, y lo que lleva la cuenta del
  // indicador de espera, es `accionDeLaSesion` (ver `enviar`).
  mixins: [soloMandaLaDeDelante, soloMandaLaVentanaDeAhora, unaAccionALaVez],
  props: {
    opened: { type: Boolean, default: false },
    /**
     * La solicitud sobre la que se pide, tal como la trae «Mis vacaciones». De ella sale todo: el
     * código, el tramo, los días, cuáles se pueden anular y la `version` con la que se envía.
     */
    solicitud: { type: Object, default: null },
    /** Quién tiene que aceptarlo, para la nota al pie. */
    aprobador: { type: String, default: '' }
  },
  data: function() {
    return {
      /** Los días marcados. Al abrir, todos los anulables, como la maqueta. */
      elegidos: [],
      motivo: ''
    };
  },
  computed: {
    /**
     * **De qué solicitud es esta ventana ahora mismo**, para `soloMandaLaVentanaDeAhora`: la
     * instancia es una sola y «Mis vacaciones» la reutiliza abriéndola con otra solicitud, así que
     * esto es lo que separa una apertura de la siguiente.
     */
    sujetoDeLaVentana: function() {
      return (this.solicitud && this.solicitud.id) || null;
    },
    nombre: function() {
      const s = this.solicitud;
      return (s && (s.nombre || s.username)) || '';
    },
    anulables: function() {
      return (this.solicitud && this.solicitud.diasAnulables) || [];
    },
    /**
     * Se puede enviar con algún día marcado y con motivo escrito. Se decide en corto y a sabiendas
     * de que el servidor lo vuelve a comprobar entero: deshabilitar el botón ahorra el viaje, no es
     * la validación.
     */
    puedeEnviar: function() {
      return this.elegidos.length > 0 && !!this.motivo.trim() && !this.enVuelo;
    },
    /**
     * Si esta petición ya está viajando. Es el cerrojo del módulo —de la solicitud, no de esta
     * ventana—, así que vale también si la misma solicitud se está resolviendo desde otro sitio:
     * con una en vuelo, la segunda llegaba a mandarse y acababa enseñando un conflicto después del
     * aviso de que había ido bien.
     */
    enVuelo: function() {
      return !!this.solicitud && this.accionEnVueloSobre(claveDeSolicitud(this.solicitud.id));
    },
    /**
     * Lo que le falta al botón, con las mismas condiciones de `puedeEnviar` y en el mismo orden.
     * Se lee del propio `puedeEnviar` quien lo mantenga: si mañana se añade una condición, se
     * añade aquí su línea, que es el precio de que el botón no se quede mudo.
     */
    loQueFalta: function() {
      // El envío en vuelo va primero y corta: mientras el servidor contesta no falta nada que
      // rellenar, y enumerar lo demás diría que el botón se desbloquea escribiendo algo.
      if (this.enVuelo) return this.$t('anularVacaciones.enVuelo');
      const falta = [];
      if (!this.elegidos.length) falta.push(this.$t('anularVacaciones.faltaDias'));
      if (!this.motivo.trim()) falta.push(this.$t('anularVacaciones.faltaMotivo'));
      if (!falta.length) return '';
      return this.$t('anularVacaciones.faltaPara', {
        que: falta.join(this.$t('anularVacaciones.faltaY'))
      });
    }
  },
  methods: {
    /**
     * Cada apertura empieza de cero. La ventana vive dentro de una pantalla con `keepAlive`, así
     * que la instancia es la misma toda la sesión: sin esto, al abrirla sobre otra solicitud se
     * quedaban los días marcados de la anterior —que no son ni siquiera días de esta— y el motivo
     * ya escrito.
     */
    abrir: function() {
      this.elegidos = this.anulables.slice();
      this.motivo = '';
    },
    esAnulable: function(dia) {
      return this.anulables.indexOf(dia) >= 0;
    },
    alternar: function(dia, marcado) {
      const i = this.elegidos.indexOf(dia);
      if (marcado && i < 0) this.elegidos.push(dia);
      if (!marcado && i >= 0) this.elegidos.splice(i, 1);
    },
    /**
     * **La petición sale por la puerta del módulo** (`accionDeLaSesion`), la misma por la que salen
     * aprobar, denegar y resolver una anulación desde la bandeja. De ahí vienen las cuatro cosas
     * que esta ventana se hacía por su cuenta, o no se hacía:
     *
     *  - el **cerrojo** de esa solicitud mientras el POST viaja, que es lo que impide que un
     *    segundo toque mande otra petición con la misma `version` y acabe enseñando un conflicto
     *    después del aviso de éxito;
     *  - el **sello de sesión**: si se cierra sesión con el POST en vuelo, su respuesta no enseña
     *    el acuse ni recarga nada sobre la cuenta siguiente;
     *  - el **sello de pantalla**, por lo mismo al salir de «Vacaciones» sin cerrar sesión;
     *  - y el **indicador de espera con dueño**: antes se encendía con `preloader.show()` y se
     *    apagaba con un `hide()` directo en el `then` final, o sea DESPUÉS de que `enviada` hubiera
     *    arrancado la recarga del resumen, así que la pantalla volvía a parecer lista enseñando
     *    todavía los datos de antes (el mismo defecto que ya costó las rondas 4 y 11 del PR #1733).
     *
     * El adaptador pone además lo suyo: una sola en vuelo y la respuesta atada a su sesión
     * (`escrituraDelModulo`), y de ahí sale el `sinNadaQueDecir` del fallo.
     */
    enviar: function() {
      const self = this;
      const app = self.$f7;
      const accion = accionDeLaSesion(self, claveDeSolicitud(self.solicitud.id));
      accion.enviar(
        RhSolicitudesVacaciones.pedirAnulacion(self.solicitud.id, self.solicitud.version,
          // Los días van ordenados como están en la solicitud, no como se fueron marcando: así lo
          // que se manda se lee igual que lo que se vio.
          self.solicitud.dias.filter(function(dia) { return self.elegidos.indexOf(dia) >= 0; }),
          self.motivo.trim()),
        {
          // El acuse y el cierre son **de esta ventana**: con el POST en vuelo se puede haber
          // cerrado y reabierto sobre otra solicitud, y entonces ni el acuse ni el cierre son
          // suyos (la misma forma que el acuse de «Anular días», revisión CODEX ronda 9).
          exito: function() {
            app.toast.create({
              text: self.$t('anularVacaciones.peticionEnviada'), position: 'center',
              closeTimeout: 3000
            }).open();
            self.$emit('cerrar');
          },
          // Y la recarga del resumen es **de la pantalla**: la petición está guardada, así que la
          // solicitud ya no ofrece «Pedir anulación» y la pantalla tiene que enseñarlo aunque esta
          // ventana se haya cerrado. La espera de esa recarga es de quien la lanza.
          pantalla: function() {
            self.$emit('enviada');
          },
          fallo: function(e) {
            // Un intento repetido que ha cortado el adaptador, o una respuesta de otra sesión, no
            // son nada que contarle a quien está delante: el aviso era para quien lo pidió.
            if (RhSolicitudesVacaciones.sinNadaQueDecir(e)) return;
            app.dialog.alert(mensajeDelServidor(e, self.$t('anularVacaciones.errorPidiendo')));
          }
        }
      );
    },
    /**
     * Cualquiera de las salidas del módulo. Lo escrito aquí —los días marcados y el motivo— es
     * de quien lo estaba escribiendo, así que al cerrar sesión se tira: la ventana vive en una ruta
     * `keepAlive` y «Mis vacaciones» la cierra por `POPUPS`, pero la instancia es la misma y al
     * reabrirla con otra cuenta se vería el motivo de la anterior hasta que `abrir()` la limpiara.
     *
     * El cerrojo de la solicitud NO se suelta aquí: lo suelta la petición que lo cogió, y
     * soltarlo desde fuera volvería a dejar salir una segunda con la misma `version` (lo suelta
     * también el cambio de cuenta, en `unaAccionALaVez`).
     */
    dejarDeMandar: function(motivo) {
      if (motivo === MOTIVO_CIERRE_DE_SESION) {
        this.elegidos = [];
        this.motivo = '';
      }
    },
    /** El tramo de la cabecera, del mismo sitio que el resto de las pantallas. */
    fechasDe: function(solicitud) {
      const self = this;
      return textoDeLasFechas(solicitud, function(iso) { return self.corta(iso); });
    },
    /**
     * «13 oct». Se compone a mano desde el texto ISO y no se parsea a `Date`: un `LocalDate` llega
     * como «2026-10-13» y pasarlo por `Date` lo movería un día según la zona del navegador. Mismo
     * criterio que «Mis vacaciones» y la bandeja.
     */
    corta: function(iso) {
      if (!iso) return '';
      const trozos = String(iso).substring(0, 10).split('-');
      if (trozos.length !== 3) return String(iso);
      return parseInt(trozos[2], 10) + ' ' + this.$t('misVacaciones.mes_' + parseInt(trozos[1], 10));
    }
  }
};
</script>
